<template>
  <div role="document">
    <section id="intro" class="container px-4 my-4">
      <div class="row">
        <div class="col-lg-12 px-lg-12 py-lg-12">
          <h1>Pronunce Della Corte Costituzionale</h1>
          <p>
            Tutte le pronunce della Corte Costituzionale marcate in Akoma Ntoso.
          </p>
          <h5>Cosa puoi fare adesso?</h5>
          <ul>
            <li>Consulta il catalogo completo in formato Akoma Ntoso nella sezione <router-link
                      to="/pronunce">"Pronunce"</router-link>.</li>
            <li>Fai una ricerca mirata <a href="#" data-toggle="modal" data-target="#modalsearch"> cliccando qui</a> oppure sul pulsante di ricerca in alto a destra.</li>
            <li>Consulta le pronunce a partire dalle annate elencate qui sotto.</li>
            <li>Scarica le annate elencate qui sotto nel formato Akoma Ntoso.</li>
          </ul>
        </div>
      </div>
    </section>
    <YearCards />
  </div>
</template>

<script>
import YearCards from '@/components/imports/YearCards';

export default {
  name: 'home',
  components: {
    YearCards,
  },
  breadcrumb: {
    label: 'Home',
  },
  async mounted() {
    return 'hi!';
  },
  computed: {
  },
  methods: {
  },
  data() {
    return {
      site: {
        baseurl: 'pippobaudo',
      },
    };
  },
};
</script>

<style lang="scss" scoped>
</style>






// WEBPACK FOOTER //
// src/components/pages/Home.vue